import { Alert, Tag } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';
import { describeSmartDefaults, getNature } from '../productStudioModes';

// ─────────────────────────────────────────────────────────────────
// Small banner that tells the user which smart defaults were
// auto-applied based on the chosen item nature. The values themselves
// are visible on the form below — this banner is the audit trail.
//
// We never silently change values without showing them — that's the
// rule from the spec.
// ─────────────────────────────────────────────────────────────────

export default function SmartDefaultsBanner({ natureKey, defaults, onChangeNature }) {
  if (!natureKey) return null;
  const nature = getNature(natureKey);
  if (!nature) return null;
  const items = describeSmartDefaults(defaults);
  return (
    <Alert
      type="success"
      showIcon
      icon={<ThunderboltOutlined />}
      style={{ marginBottom: 12, fontSize: 12.5 }}
      message={
        <span>
          <strong>{nature.label}</strong> — suggested defaults applied.
          {typeof onChangeNature === 'function' ? (
            <a
              role="button"
              tabIndex={0}
              onClick={onChangeNature}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onChangeNature(); }}
              style={{ marginLeft: 8, fontSize: 12 }}
            >
              Change
            </a>
          ) : null}
        </span>
      }
      description={
        items.length > 0 ? (
          <div style={{ marginTop: 4, display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {items.map((label) => (
              <Tag key={label} style={{ margin: 0, fontSize: 11 }}>{label}</Tag>
            ))}
          </div>
        ) : null
      }
    />
  );
}
